import momentTZ from 'moment-timezone'
import React from 'react'
import ReactDOM from 'react-dom'
import { App, AppContext } from './containers/App'

momentTZ.tz.setDefault('UTC')

ReactDOM.render(
  <AppContext>
    <App />
  </AppContext>,
  document.getElementById('root'),
)
